import { Alert } from "antd";
import { useTranslation } from "react-i18next"
import { PageView } from "../components/PageView";


export default function PageNotFound() {
    const { t } = useTranslation("appxweb");

    return (
        <PageView
            leadText={t('SignUpRequest.leadText')}
            title={t('Page Not Found')}
        >
            <Alert
                 message="Error"
                 description={t('SignUpRequest.alert_error')}
                 type="error"
                 showIcon
            />
        </PageView>
    );
}
